import { render, staticRenderFns } from "./PhotoCard.vue?vue&type=template&id=71457b1a&"
import script from "./PhotoCard.vue?vue&type=script&lang=js&"
export * from "./PhotoCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports